import React from 'react';
import { Chip } from '@mui/material';

/**
 * Único vocabulário de status de Lead usado em toda a aplicação (Gerenciar Leads,
 * WhatsApp Web, e qualquer outra tela que precise mostrar em que pé está um lead).
 * Não duplicar este switch em outro lugar -- importar daqui.
 */
export const LEAD_STATUS_OPTIONS = [
  { value: 'novo', label: 'Novo' },
  { value: 'em_contato', label: 'Contatado' },
  { value: 'convertido', label: 'Convertido' },
  { value: 'perdido', label: 'Perdido' },
  { value: 'exportado', label: 'Exportado' },
] as const;

export const getLeadStatusChip = (status?: string | null) => {
  const normalized = (status || '').toLowerCase();
  switch (normalized) {
    case 'novo':
      return <Chip label="Novo" color="primary" size="small" />;
    case 'em_contato':
      return <Chip label="Contatado" color="warning" size="small" />;
    case 'convertido':
      return <Chip label="Convertido" color="success" size="small" />;
    case 'perdido':
      return <Chip label="Perdido" color="error" size="small" />;
    case 'exportado':
      return <Chip label="Exportado" color="secondary" size="small" />;
    default:
      return <Chip label={status || '-'} color="default" size="small" />;
  }
};
